import { Controller } from "@hotwired/stimulus"

// Submits the enclosing form when the element changes. Replaces inline
// onchange="this.form.requestSubmit()", which the CSP refuses to execute.
// Usage: data: { controller: "auto-submit", action: "change->auto-submit#submit" }
export default class extends Controller {
  submit() {
    this.element.form?.requestSubmit()
  }
}
